import {
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Attachment from '@material-ui/icons/Attachment';
import DeleteIcon from '@material-ui/icons/DeleteSweepOutlined';
import SaveIcon from '@material-ui/icons/Save';
import ThumbDownIcon from '@material-ui/icons/ThumbDownAltOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUpAltOutlined';
import TrendingUp from '@material-ui/icons/TrendingUp';
import classnames from 'classnames';
import { format, parse } from 'date-fns';
import React from 'react';
import NumberFormat from 'react-number-format';
import ElementoApi from '../../api/ElementoApi';
import GuiaApi from '../../api/GuiaApi';
import { withAuditoria } from '../../contexts/AuditoriaContext';
import { withLoading } from '../../contexts/LoadingContext';
import { withSnackbar } from '../../contexts/SnackbarContext';
import FormDialogAnexarDocumentos from '../auditoriaCNU/FormDialogAnexarDocumentos';
import AlertDialogSlide from './AlertDialogSlide';
import AlertDialog from './AlertDialog';
import AlertDialogSlideGlosa from './AlertDialogSlideGlosa';
import ButtonAlertas from './ButtonAlertas';
import ButtonEquipe from './ButtonEquipe';
import ButtonGlosas from './ButtonGlosas';
import ButtonMotivoRecurso from './ButtonMotivoRecurso';
import DrawerGuiasDuplicidade from './DrawerGuiasDuplicidade';

const styles = theme => ({
  root: {
    display: 'block',
    padding: theme.spacing(1),
    margin: theme.spacing(0.25),
    marginTop: theme.spacing(1),
    // minWidth: '48vw',
    // maxWidth: '48vw',

  },
  tituloElementoContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  tituloElemento: {
    fontWeight: 'bold',
    color: '#414141',
  },
  textField: {
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(10),
  },
  inputResize: {
    fontSize: '14px',
    padding: '4px 0 2px 0',
  },
  tableRow: {
    display: 'flex',
    height: theme.spacing(4),
  },
  tableBody: {
    display: 'block',
  },
  tableHeadCell: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
  },
  /*Coluna Total Glosado*/
  tableHeadCellGlosado: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'left',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
    width: theme.spacing(12),
  },
  tableCellDetalheGlosado: {
    color: 'red',
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    width: theme.spacing(12),
    display: 'inline-flex',
    fontSize: 13,
  },
  tableCellDetalheSemGlosa: {
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    width: theme.spacing(12),
    display: 'inline-flex',
    fontSize: 13,
  },
  tableHeadCellMais: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(20),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
  },
  tableRowCell: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'flex-start',
    textAlign: 'left',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
  },
  tableCell: {
    fontSize: '14px',
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
  },
  tableCellGlosa: {
    fontSize: '14px',
    color: 'red',
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
  },
  tableCellMaisGlosa: {
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
  },
  tableCellMais: {
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(20),
  },
  tableCellMaisToolbar: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },

  editableClick: {
    fontSize: '0.7em',
    fontStyle: 'italic',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  buttonOperation: {
    fontSize: 'small',
    margin: theme.spacing(0.25),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minWidth: theme.spacing(3),
    maxWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
    '&:hover': {
      border: `0px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.text.hint
    },
  },
  tableCellBold: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
    fontSize: '0.8em',
    fontStyle: 'italic',
  },
  autorizado: {
    backgroundColor: 'rgb(223, 240, 216)',
    border: '1px solid #ABCCAB',
    '&:hover': {
      border: '1px solid grey',
    },
  },
  negado: {
    backgroundColor: 'rgb(242, 222, 222)',
    border: '1px solid rgb(187, 136, 136)',
    '&:hover': {
      border: '1px solid black',
    },
  },
  glosado: {
    backgroundColor: 'rgb(252, 248, 227)',
    border: '1px solid rgb(187, 187, 136)',
    '&:hover': {
      border: '1px solid grey',
    },
  },
  typographyAvaliadoEditable: {
    fontSize: '14px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
    fontWeight: 'bold',
    justifyContent: 'center',
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(4),
  },
  buttonAnexos: {
    fontSize: 'small',
    marginBottom: theme.spacing(1),
    margin: theme.spacing(0.25),
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
    '&:hover': {
      border: `0px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.text.hint
    },
  },
  divBox: {
    display: '-webkit-box'
  },
  typographyEnabled: {
    color: '#3f51b5',
  },
  checkNegarEmLote: {
    marginLeft: theme.spacing(-1.5),
    marginRight: theme.spacing(-0.5),
  },
  typographyDisabled: {
    typographyBadge: {
      marginLeft: theme.spacing(1) * -1,
      marginRight: theme.spacing(1) * -1,
      color: '#3f51b5',
    },
    badgeDisabled: {
      top: '0%',
      right: -5,
      width: theme.spacing(2),
      height: theme.spacing(2),
      color: 'rgba(0, 0, 0, 0.26)',
    }
  }
});

const SEQ_PRESTADOR_CNU = 28009;

class Elemento extends React.Component {
  guiaApi = new GuiaApi();
  elementoApi = new ElementoApi();

  constructor(props) {
    super(props);
    this.state = {
      elementoSelected: { ...props.elemento, dtaRealizacao: parse(props.elemento.dtaRealizacao) },
      elementoSelectedIdx: props.idx,
      situacaoElemento: this.getSituacao(props.elemento),
      openDialogGlosaElemento: false,
      guiasDuplicidades: [],
      openDrawerGuiasDuplicidade: false,
      openDialogAnexos: false,
      openDialogGlosaEmLote: false,
      dialogTitleGlosaEmLote: 'Glosa de elementos em lote',
      dialogMessageGlosaEmLote: '',
      indReplicarGlosas: false,
      // checked: this.props.elemento.checked,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.elemento.codItem !== this.props.elemento.codItem ||
      prevProps.elemento.qtdAutorizada !== this.props.elemento.qtdAutorizada ||
      prevProps.elemento.valPctReducaoAcrescimoAutorizado !== this.props.elemento.valPctReducaoAcrescimoAutorizado ||
      prevProps.elemento.valTotalAutorizado !== this.props.elemento.valTotalAutorizado ||
      prevProps.elemento.valUnitarioAutorizado !== this.props.elemento.valUnitarioAutorizado ||
      prevProps.elemento.glosas.length !== this.props.elemento.glosas.length) {
      this.updateElementoSelected();
    }
  }

  updateElementoSelected() {
    this.props.elemento.dtaRealizacao = parse(this.props.elemento.dtaRealizacao);
    this.setState({ elementoSelected: this.props.elemento });
  }

  styleSituacaoElemento = (situacao) => {
    const { classes } = this.props;

    let classe = classes.default;

    if (situacao === 'negado') {
      classe = classes.negado;
    }
    if (situacao === 'autorizado') {
      classe = classes.autorizado;
    }
    if (situacao === 'glosado') {
      classe = classes.glosado;
    }

    return classe;
  }

  getSituacao = (elemento) => {
    const { valTotalSolicitado, valTotalAutorizado } = elemento;
    let situacao;

    if (this.isElementoAuditado(elemento)) {
      const solic = Number(valTotalSolicitado.toFixed(2));
      const autor = Number(valTotalAutorizado.toFixed(2));

      let diff = solic - autor;
      if (elemento.indReapresentacao === 'S' && diff !== 0) {
        diff = (solic + elemento.elementoOriginalDTO.valTotalAutorizado) - autor;
      }

      if (valTotalAutorizado === 0) {
        situacao = 'negado';
      } else if (diff <= 0) {
        situacao = 'autorizado';
      } else if (diff > 0) {
        situacao = 'glosado';
      }
    } else {
      situacao = 'sem_auditoria';
    }
    if (this.props.isGuiaSolicitacao) {
      situacao = 'sem_auditoria';
    }
    return situacao;
  }

  isElementoAuditado(elemento) {
    const { qtdAutorizada, valUnitarioAutorizado, valPctReducaoAcrescimoAutorizado, valTotalAutorizado } = elemento;

    const isAuditado =
      qtdAutorizada !== null &&
      valUnitarioAutorizado !== null &&
      valPctReducaoAcrescimoAutorizado !== null &&
      valTotalAutorizado !== null;

    return isAuditado;
  }

  haGlosa(elemento) {
    const { valTotalSolicitado, valTotalAutorizado } = elemento;

    const haGlosa = (valTotalAutorizado === 0) || (valTotalAutorizado !== null && Math.round(valTotalAutorizado * 100) / 100 < valTotalSolicitado);

    return haGlosa;
  }

  addGlosaElemento = () => {
    this.setState({ openDialogGlosaElemento: true });
  }

  handleCloseDialogGlosaElemento = () => {
    this.setState({ openDialogGlosaElemento: false });
  }

  handleConfirmDialogGlosaElemento = async (codMensagemGlosa, desMensagemGlosa, desObservacao) => {
    let newElemento = { ...this.state.elementoSelected };

    let glosaJaExiste = false;
    let glosaAtual = {
      codItemPai: newElemento.id,
      codMensagemGlosa: codMensagemGlosa,
      desMensagemGlosa: desMensagemGlosa,
      txtObservacao: desObservacao || ''
    };

    newElemento.glosas.forEach(glosa => {
      if (glosa.codMensagemGlosa === codMensagemGlosa) {
        glosaJaExiste = true;
        glosa.txtObservacao = glosaAtual.txtObservacao || '';
      }
    });

    if (!glosaJaExiste) {
      newElemento.glosas = [...this.state.elementoSelected.glosas, glosaAtual];
    }

    let numOcorrencias = this.contaElementosMesmoCodigo();
    const { valTotalSolicitado, valTotalAutorizado } = newElemento;
    const haGlosa = valTotalAutorizado !== null && valTotalAutorizado < valTotalSolicitado && valTotalAutorizado !== 0;

    if (numOcorrencias > 0 && haGlosa) {
      this.setState({
        dialogMessageGlosaEmLote: 'O item ' + this.state.elementoSelected.codItem + ' - ' + this.state.elementoSelected.desItem
          + ' ocorre outra(s) ' + numOcorrencias + ' vez(es) nesta guia.'
          + ' Deseja replicar a(s) glosa(s) (Valor Unitário, Quantidade, Código da Glosa e Observação) para o(s) outro(s) elemento(s) idêntico(s)?'
          + ' A operação será efetuada ao clicar no botão Salvar Auditoria deste elemento.',
        openDialogGlosaEmLote: true
      });
    }
    this.setState({ elementoSelected: newElemento });

    this.handleCloseDialogGlosaElemento();
  }
  contaElementosMesmoCodigo = () => {
    let cont = 0;
    for (var i = 0; i < this.props.elementosDaGuia.length; i++) {
      if (this.state.elementoSelected.codItem == this.props.elementosDaGuia[i].codItem &&
        this.state.elementoSelected.codTabela == this.props.elementosDaGuia[i].codTabela) {
        cont = cont + 1;
      }
    }
    return cont - 1;
  }
  handleCloseDialogGlosaEmLote = () => {
    this.setState({ openDialogGlosaEmLote: false });
  }
  handleDialogConfirmGlosaEmLote = () => {
    this.setState({ indReplicarGlosas: true, openDialogGlosaEmLote: false });
  }

  salvarAuditoria = async (elementoSelected) => {
    const { glosas } = elementoSelected;
    const { situacaoElemento } = this.state;

    if (['negado', 'glosado'].includes(situacaoElemento) && glosas.length === 0) {
      this.props.showSnackbar('Para salvar um item com glosa adicione um motivo de glosa', 'warning', 4000, '', null, 'bottom');
      return;
    }

    this.props.showLoading('Salvando...');
    let result = await this.elementoApi.salvarAuditoriaElemento(this.props.loteSelecionado.codLote, elementoSelected);

    if (result !== undefined && result.data.codigoRetorno === 1) {
      // Realiza a glosa em lote para elementos repetidos na mesma guia
      let numOcorrencias = this.contaElementosMesmoCodigo();
      const { valTotalSolicitado, valTotalAutorizado } = elementoSelected;
      const haGlosa = valTotalAutorizado !== null && valTotalAutorizado < valTotalSolicitado && valTotalAutorizado !== 0;
      if (this.state.indReplicarGlosas && numOcorrencias > 0 && haGlosa) {
        for (var i = 0; i < this.props.elementosDaGuia.length; i++) {
          if (elementoSelected.codItem == this.props.elementosDaGuia[i].codItem &&
            elementoSelected.codTabela == this.props.elementosDaGuia[i].codTabela &&
            elementoSelected.id !== this.props.elementosDaGuia[i].id) {

            let newElemento = { ...this.props.elementosDaGuia[i] };
            newElemento.glosas = elementoSelected.glosas;
            newElemento.valUnitarioAutorizado = elementoSelected.valUnitarioAutorizado;
            newElemento.qtdAutorizada = elementoSelected.qtdAutorizada;
            newElemento.valPctReducaoAcrescimoAutorizado = elementoSelected.valPctReducaoAcrescimoSolicitado;
            newElemento.valTotalAutorizado = newElemento.qtdAutorizada * newElemento.valUnitarioAutorizado * newElemento.valPctReducaoAcrescimoAutorizado;
            newElemento.dtaRealizacao = parse(newElemento.dtaRealizacao);
            result = await this.elementoApi.salvarAuditoriaElemento(this.props.loteSelecionado.codLote, newElemento);
          }
        }
      }
    }
    /**/

    this.props.hideLoading();

    if (result === undefined || result.data === undefined) {
      this.props.showSnackbar('Não foi possível realizar a operação.', 'error', 4000, '', null, 'bottom');
      return;
    }
    if (result !== undefined && result.data.codigoRetorno === 1) {
      this.props.onOperacaoRealizada();
      this.props.showSnackbar(result.data.msgRetornoResumida, 'success', 4000, '', null, 'bottom');
    } else {
      const { mensagens } = result.data;
      this.props.showSnackbar(mensagens, 'error', 4000, '', null, 'bottom');
    }
  }

  handleChangeValueQtde = (floatValue) => {
    const valTotalAutorizado =
      floatValue *
      this.state.elementoSelected.valUnitarioAutorizado *
      this.state.elementoSelected.valPctReducaoAcrescimoAutorizado;

    const newSelected = {
      ...this.state.elementoSelected,
      qtdAutorizada: floatValue,
      valTotalAutorizado: Number.isNaN(valTotalAutorizado) ? null
        : Number(this._roundUp(valTotalAutorizado, this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3).toFixed(this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3))
    };

    if (this.state.elementoSelected.indReapresentacao === 'S') {
      newSelected.valTotalAutorizado = valTotalAutorizado === null || valTotalAutorizado === 0 ? 0 : (valTotalAutorizado - this.state.elementoSelected.elementoOriginalDTO.valTotalAutorizado);
    }
    
    newSelected.valTotalAutorizado = this._roundUp(newSelected.valTotalAutorizado, 3);
    const novaSituacao = this.getSituacao(newSelected);

    this.setState({ elementoSelected: newSelected, situacaoElemento: novaSituacao });

    // this.setState({ elementoSelected: newSelected });
  }

  handleChangeValueUnitario = (floatValue) => {

    const valTotalAutorizado =
      this.state.elementoSelected.qtdAutorizada *
      floatValue *
      this.state.elementoSelected.valPctReducaoAcrescimoAutorizado;

    const newSelected = {
      ...this.state.elementoSelected,
      valUnitarioAutorizado: floatValue,
      valTotalAutorizado: Number.isNaN(valTotalAutorizado) ? null
        : Number(this._roundUp(valTotalAutorizado, this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3).toFixed(this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3))
    };
    if (this.state.elementoSelected.indReapresentacao === 'S') {
      newSelected.valTotalAutorizado = valTotalAutorizado === null || valTotalAutorizado === 0 ? 0 : (valTotalAutorizado - this.state.elementoSelected.elementoOriginalDTO.valTotalAutorizado);
    }
    
    newSelected.valTotalAutorizado = this._roundUp(newSelected.valTotalAutorizado, 3);
    const novaSituacao = this.getSituacao(newSelected);

    this.setState({ elementoSelected: newSelected, situacaoElemento: novaSituacao });
  }

  handleChangeValuePct = (floatValue) => {
    let valTotalAutorizado =
      this.state.elementoSelected.qtdAutorizada *
      this.state.elementoSelected.valUnitarioAutorizado *
      floatValue;

    if (this.state.elementoSelected.valUnitarioAutorizado === null || this.state.elementoSelected.qtdAutorizada === null) {
      valTotalAutorizado = NaN;
      floatValue = null;
    }
    const newSelected = {
      ...this.state.elementoSelected,
      valPctReducaoAcrescimoAutorizado: floatValue === undefined ? 0 : floatValue,
      valTotalAutorizado: Number.isNaN(valTotalAutorizado) ? null
        : Number(this._roundUp(valTotalAutorizado, this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3).toFixed(this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3))
    };
    if (this.state.elementoSelected.indReapresentacao === 'S') {
      newSelected.valTotalAutorizado = valTotalAutorizado === null || valTotalAutorizado === 0 ? 0 : (valTotalAutorizado - this.state.elementoSelected.elementoOriginalDTO.valTotalAutorizado);
    }

    newSelected.valTotalAutorizado = this._roundUp(newSelected.valTotalAutorizado, 3);
    const novaSituacao = this.getSituacao(newSelected);

    this.setState({ elementoSelected: newSelected, situacaoElemento: novaSituacao });

    // this.setState({ elementoSelected: newSelected, });
  }

  handleClickOnElemento = async (idx, elemento) => {
    // esse elemento veio via props
    if (idx !== this.state.elementoSelectedIdx) {
      elemento.dtaRealizacao = parse(elemento.dtaRealizacao);
      this.setState({
        elementoSelectedIdx: idx,
        elementoSelected: elemento
      });
    }
  }

  handleFocusOnInput = (event) => {
    event.target.select();
  }

  // Calcula automaticamento o percentual
  // e valor unitário autorizado para pagar
  // o valor total solicitado pelo prestaodr
  maxTotalAutorizado = () => {
    const { valUnitarioVigente, valTotalSolicitado, valTaxaVigente, qtdAutorizada, valUnitarioSolicitado, tipoElementoGuia } = this.state.elementoSelected;
    let percSelecionado = 1.0000;
    if (valTaxaVigente !== '1.0000' &&
      valTaxaVigente !== '0.0000' &&
      valTaxaVigente !== null) {
      percSelecionado = Number(valTaxaVigente);
    }
    let totalAutorizadoCalculado;
    let valUnitarioSelecionado = valUnitarioVigente < valUnitarioSolicitado ? valUnitarioVigente : valUnitarioSolicitado;
    let cpyPercAutorizado = percSelecionado;
    let cpyQtdeAutorizado = qtdAutorizada;
    let cpyValUnitarioAutorizado = valUnitarioSelecionado;
    let precisao = tipoElementoGuia === 'OPME' ? 1000 : 100;

    if (tipoElementoGuia !== 'OPME') {

      while (cpyQtdeAutorizado > 0) {
        while (cpyPercAutorizado > 0) {
          totalAutorizadoCalculado = Number(cpyQtdeAutorizado * valUnitarioSelecionado * cpyPercAutorizado);
          totalAutorizadoCalculado = Math.round(totalAutorizadoCalculado * precisao) / precisao;

          if (totalAutorizadoCalculado <= valTotalSolicitado) {
            if (totalAutorizadoCalculado < valTotalSolicitado) {
              cpyQtdeAutorizado = cpyQtdeAutorizado - 1;
              cpyPercAutorizado = percSelecionado;
              if (cpyQtdeAutorizado <= 0) {
                break;
              }
            } else {
              break;
            }
          } else {
            cpyPercAutorizado = Number((cpyPercAutorizado - 0.0001));
          }
        }
        if (cpyQtdeAutorizado <= 0 || (totalAutorizadoCalculado <= valTotalSolicitado)) {
          break;
        }
      }

      if (cpyQtdeAutorizado > 0) {
        const newElemento = {
          ...this.state.elementoSelected,
          glosas: [],
          qtdAutorizada: cpyQtdeAutorizado,
          valUnitarioAutorizado: valUnitarioSelecionado,
          valPctReducaoAcrescimoAutorizado: cpyPercAutorizado,
          valTotalAutorizado: totalAutorizadoCalculado,
        };

        this.setState({ elementoSelected: newElemento, indReplicarGlosas: false });
      } else {
        this.props.showSnackbar('Não foi possível calcular um valor válido para este item.', 'error', 4000, '', null, 'top', 'right');
      }
    } else {
      while (cpyValUnitarioAutorizado > 0) {
        totalAutorizadoCalculado = Number(qtdAutorizada * cpyValUnitarioAutorizado * percSelecionado);
        totalAutorizadoCalculado = Math.round(totalAutorizadoCalculado * precisao) / precisao;
        if (totalAutorizadoCalculado > valTotalSolicitado) {
          cpyValUnitarioAutorizado = 0;
          break;
        } else {
          if (totalAutorizadoCalculado === valTotalSolicitado) {
            break;
          } else {
            cpyValUnitarioAutorizado = Number((cpyValUnitarioAutorizado + 0.0001));
          }
        }
      }
      if (cpyValUnitarioAutorizado > 0) {
        const newElemento = {
          ...this.state.elementoSelected,
          glosas: [],
          qtdAutorizada: qtdAutorizada,
          valUnitarioAutorizado: cpyValUnitarioAutorizado,
          valPctReducaoAcrescimoAutorizado: percSelecionado,
          valTotalAutorizado: totalAutorizadoCalculado,
        };

        this.setState({ elementoSelected: newElemento, indReplicarGlosas: false });
      } else {
        this.props.showSnackbar('Não foi possível calcular um valor válido para este item.', 'error', 4000, '', null, 'top', 'right');
      }
    }
  }
  dobrarValor = () => {
    const { valUnitarioAutorizado, valTotalSolicitado, valTotalAutorizado } = this.state.elementoSelected;
    const newElemento = {
      ...this.state.elementoSelected,
      valUnitarioAutorizado: (2 * valUnitarioAutorizado) > valTotalSolicitado ? (valUnitarioAutorizado * 2) - 0.01 : valUnitarioAutorizado * 2,
      valTotalAutorizado: (2 * valUnitarioAutorizado) > valTotalSolicitado ? (2 * valTotalSolicitado - 0.01) : valTotalAutorizado * 2
    };
    const novaSituacao = this.getSituacao(newElemento);
    this.setState({ elementoSelected: newElemento, situacaoElemento: novaSituacao, indReplicarGlosas: false });
  }
  dividirValorMetade = () => {
    const { valUnitarioAutorizado, valTotalSolicitado } = this.state.elementoSelected;
    const newElemento = {
      ...this.state.elementoSelected,
      valUnitarioAutorizado: (valUnitarioAutorizado / 2),
      valTotalAutorizado: (valTotalSolicitado / 2)
    };
    const novaSituacao = this.getSituacao(newElemento);
    this.setState({ elementoSelected: newElemento, situacaoElemento: novaSituacao, indReplicarGlosas: false });
  }
  autorizar = async (elementoSelected) => {
    const newElemento = {
      ...this.state.elementoSelected,
      glosas: [],
      qtdAutorizada: elementoSelected.qtdSolicitada,
      valUnitarioAutorizado: elementoSelected.valUnitarioSolicitado,
      valPctReducaoAcrescimoAutorizado: elementoSelected.valPctReducaoAcrescimoSolicitado || 1,
      valTotalAutorizado: elementoSelected.indReapresentacao !== 'S'
        ? elementoSelected.valTotalSolicitado
        : this._roundUp((elementoSelected.qtdSolicitada *
          elementoSelected.valUnitarioSolicitado *
          elementoSelected.valPctReducaoAcrescimoSolicitado || 1) - elementoSelected.elementoOriginalDTO.valTotalAutorizado, 3)
    };
    const novaSituacao = this.getSituacao(newElemento);
    this.setState({ elementoSelected: newElemento, situacaoElemento: novaSituacao, indReplicarGlosas: false });
  }

  negar = async () => {
    const newElemento = {
      ...this.state.elementoSelected,
      qtdAutorizada: 0,
      valUnitarioAutorizado: 0,
      valPctReducaoAcrescimoAutorizado: 0,
      valTotalAutorizado: 0,
    };

    const novaSituacao = this.getSituacao(newElemento);

    this.setState({ elementoSelected: newElemento, situacaoElemento: novaSituacao, indReplicarGlosas: false });

  }

  apagar = async () => {
    const newElemento = {
      ...this.state.elementoSelected,
      glosas: [],
      qtdAutorizada: null,
      valUnitarioAutorizado: null,
      valPctReducaoAcrescimoAutorizado: null,
      valTotalAutorizado: null,
    };

    const novaSituacao = this.getSituacao(newElemento);

    this.setState({ elementoSelected: newElemento, situacaoElemento: novaSituacao, indReplicarGlosas: false });

    // this.setState({ elementoSelected: newElemento, });
  }

  isElementoEmEdicao() {
    return this.state.elementoSelected.qtdAutorizada !== this.props.elemento.qtdAutorizada ||
      this.state.elementoSelected.valPctReducaoAcrescimoAutorizado !== this.props.elemento.valPctReducaoAcrescimoAutorizado ||
      this.state.elementoSelected.valTotalAutorizado !== this.props.elemento.valTotalAutorizado ||
      this.state.elementoSelected.valUnitarioAutorizado !== this.props.elemento.valUnitarioAutorizado ||
      this.state.elementoSelected.glosas !== this.props.elemento.glosas;
  }

  isAuditoriaApagada = () => {
    const { qtdAutorizada, valUnitarioAutorizado, valPctReducaoAcrescimoAutorizado } = this.state.elementoSelected;
    let isApagada = false;
    isApagada = qtdAutorizada === null || valUnitarioAutorizado === null || valPctReducaoAcrescimoAutorizado === null;

    return isApagada;
  }
  isPossivelDobrarValor = () => {
    return this.state.elementoSelected.valUnitarioAutorizado !== 0 &&
      this.state.elementoSelected.valUnitarioAutorizado !== null &&
      ((this.state.elementoSelected.valTotalSolicitado + 0.01) >= (this.state.elementoSelected.valTotalAutorizado * 2));
  }
  isPossivelDividirMetade = () => {
    return this.state.elementoSelected.valUnitarioAutorizado !== 0 &&
      this.state.elementoSelected.valUnitarioAutorizado !== null;
  }
  
  handleExcluirGlosa = async (codMensagemGlosa) => {
    const newElemento = {
      ...this.state.elementoSelected
    };

    let excluidos = [];
    for (let i = 0; i < newElemento.glosas.length; i++) {
      let glosaCorrente = newElemento.glosas[i];

      if (glosaCorrente.codMensagemGlosa === codMensagemGlosa) {
        excluidos.push(i);
      }
    }

    for (let j = 0; j < excluidos.length; j++) {
      let id = excluidos[j];
      newElemento.glosas.splice(id, 1);
    }

    this.setState({ elementoSelected: newElemento });
  }

  handleViewDuplicidades = async (elemento) => {
    this.props.showLoading('Carregando..');
    const guiasDuplicidades = await this.guiaApi.consultarGuiasDuplicadas(this.props.loteSelecionado.codLote, elemento.codGuia, elemento);
    this.props.setGuiasEmDuplicidade(guiasDuplicidades);

    this.setState({ openDrawerGuiasDuplicidade: true });
    this.props.hideLoading();
  }

  handleDrawerCloseGuiaDuplicidade = () => {
    this.setState({ openDrawerGuiasDuplicidade: false, });
    this.props.setGuiasEmDuplicidade([]);
  }
  handleClickAnexos = (elementoSelected) => {
    this.setState({ openDialogAnexos: true, elementoSelected: elementoSelected });
  };
  handleDialogCloseAnexos = () => {
    this.setState({ openDialogAnexos: false });
  };
  exibirJustificativa = (elemento) => {
    this.setState({ openDialogJustificativa: true, dialogTitle: 'Justificativa da Exclusão', dialogMessage: elemento.txtJustificativaExclusao });
  }
  handleCloseDialogJustificativa = () => {
    this.setState({ openDialogJustificativa: false });
  }
  _roundUp = (num, precision) => {
    precision = Math.pow(10, precision);
    return Math.round(Number(num) * precision) / precision;
  }

  _currency = (val) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 3 }).format(val);
  }
  selecionarValor = (valor) => {
    // this.handleClickOnElemento(this.props.idx, this.props.elemento);
    this.handleChangeValueUnitario(valor);
  }

  render() {
    const { classes, idx, readOnly, emAuditoria, elemento, isSelecionado } = this.props;
    const { elementoSelected } = this.state;
    // console.log('isSelecionado', isSelecionado);    

    const titleElemento =
      <div>
        {elementoSelected.indReapresentacao === 'S' &&
          <div className={classes.tituloElementoContainer}>
            <Typography
              component={'span'}
              className={classes.tituloElemento}
              title={`ITEM ORIGINAL - Tabela: ${elemento.elementoOriginalDTO.codTabela} - ${elemento.elementoOriginalDTO.desTabela}`}>
              {`ORIGINAL : ${elemento.elementoOriginalDTO.desTabela} • ${elemento.elementoOriginalDTO.codItem} ${elemento.elementoOriginalDTO.desTipoOutrasDesp || ''} ${elemento.elementoOriginalDTO.desItem}`}
            </Typography>
            <Toolbar className={classes.tableCellMaisToolbar} disableGutters>
              <ButtonGlosas
                title={[elemento.elementoOriginalDTO.codItem, elemento.elementoOriginalDTO.desItem]}
                glosas={elemento.elementoOriginalDTO.glosas}
                emAuditoria={false} />
            </Toolbar>
          </div>
        }
        <div className={classes.tituloElementoContainer}>

          <FormControlLabel
            control={
              
              <Checkbox
                disabled={elemento.valTotalAutorizado === 0 || readOnly}
                checked={isSelecionado ? true : false}
                onChange={() => this.props.selecionarElemento(elemento)}
                title='Marcar Item para Autorizar/Negar em Lote'
              />
            }
            className={classes.checkNegarEmLote}
          />
                    
          <Typography
            component={'span'}
            className={classes.tituloElemento}
            title={`Tabela: ${elemento.codTabela} - ${elemento.desTabela}`}>
            {elementoSelected.indReapresentacao === 'S' && 'RECURSO : '}{`${elemento.desTabela} • ${elemento.codItem} ${elemento.desTipoOutrasDesp || ''} ${elemento.desItem}`}
            
            {elemento.dtaRealizacao !== null && (
              <Typography component={'p'} className={classes.secondaryHeading} title='Data da realização e hora'>
                {this.props.isGuiaSolicitacao ? 'solicitado em' : 'realizado em'} {format(elemento.dtaRealizacao, 'DD/MM/YYYY')}  {elemento.horInicio === null ? ' ' : ' ' + elemento.horInicio}
              </Typography>
            )}
          </Typography>


        </div>
        {elemento.txtJustificativaExclusao !== null
          ? <div className={classes.divBox}>
            <Button
              color='inherit'
              variant='contained'
              className={classes.buttonAnexos}
              title='Visualizar anexos'
              onClick={() => this.handleClickAnexos(elemento)}
              component='span'>
              <Attachment />
              Anexos...
            </Button>
            <Typography
              className={classes.typographyAvaliadoEditable}
              title={'Click para ver a justificativa de exclusão'}
              onClick={() => this.exibirJustificativa(elemento)}>{'GLOSA REJEITADA PELA CNU'}</Typography>
          </div>
          : null
        }

      </div>;

    const rowHead = <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableHeadCell} />
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Quantidade'>Qtde.</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Valor unitário'>Val. unitário</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Percentual de redução e acréscimo.'>% Red./Acr.</TableCell>}
      {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableHeadCell} title='Valor que já foi Pago na guia original'>Pago</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Valor total'>Total</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCellGlosado} title='Valor Glosado'>Total Glosado</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCellMais} title='Mais'>Mais</TableCell>}
    </TableRow>;

    const txtAjudaPercSolicitado =
      `${elementoSelected.valPctReducaoAcrescimoSolicitado === '1.0000' ||
        elementoSelected.valPctReducaoAcrescimoSolicitado === '0.0000' ||
        elementoSelected.valPctReducaoAcrescimoSolicitado === null
        ? 'Nenhum percentual de redução ou acrécimo solicitado.'
        : `O prestador está solicitando ${parseFloat((elementoSelected.valPctReducaoAcrescimoSolicitado - 1) * 100).toFixed(2)}% de ${elementoSelected.valPctReducaoAcrescimoSolicitado < 1 ? 'redução' : 'acréscimo'}.`}`;

    const rowSolicitado =
      <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableRowCell}>Solicitado</TableCell>
        <TableCell className={classes.tableCell}>{elementoSelected.qtdSolicitada}</TableCell>
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{this._currency(elementoSelected.valUnitarioSolicitado)}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell} title={txtAjudaPercSolicitado}>{elementoSelected.valPctReducaoAcrescimoSolicitado}</TableCell>}
        {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableCell} title='Valor que já foi Pago na guia original'>{this._currency(elementoSelected.elementoOriginalDTO.valTotalAutorizado)}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{this._currency(elementoSelected.valTotalSolicitado)}</TableCell>}
        <TableCell className={classes.tableCell} />
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') &&
          <TableCell className={classes.tableCellMais}>
            <Toolbar className={classes.tableCellMaisToolbar} disableGutters>
              <ButtonGlosas
                title={[elementoSelected.codItem, elementoSelected.desItem]}
                glosas={elementoSelected.glosas}
                emAuditoria={emAuditoria}
                handleExcluirGlosa={(codMensagemGlosa) => this.handleExcluirGlosa(codMensagemGlosa)} />
              <ButtonMotivoRecurso
                title={[elementoSelected.codItem, elementoSelected.desItem]}
                motivo={elementoSelected.txtMotivoRecurso}
              />
              <ButtonAlertas
                title={[elementoSelected.codItem, elementoSelected.desItem]}
                alertas={elementoSelected.alertas}
                handleViewDuplicidades={() => this.handleViewDuplicidades(elemento)}
              />
              <ButtonEquipe
                title={[elementoSelected.codItem, elementoSelected.desItem]}
                equipe={elementoSelected.equipe}
                valUnitarioVigente={elementoSelected.valUnitarioVigente}
                codPorteAnestesico={elementoSelected.codPorteAnestesico}
                dtaRealizacao={elementoSelected.dtaRealizacao}
                selecionarValor={this.selecionarValor} />
            </Toolbar>
          </TableCell>}
      </TableRow >;

    const txtAjudaPercAutorizado =
      `${elementoSelected.valPctReducaoAcrescimoAutorizado === '1.0000' ||
        elementoSelected.valPctReducaoAcrescimoAutorizado === '0.0000' ||
        elementoSelected.valPctReducaoAcrescimoAutorizado === null
        ? 'Nenhum percentual de redução ou acrécimo autorizado.'
        : `Está sendo autorizado ${parseFloat((elementoSelected.valPctReducaoAcrescimoAutorizado - 1) * 100).toFixed(2)}% de ${elementoSelected.valPctReducaoAcrescimoAutorizado < 1 ? 'redução' : 'acréscimo'}.`}`;

    const rowAutorizado = emAuditoria
      ? <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableRowCell}>Autorizado</TableCell>
        <TableCell className={classes.tableCell}>
          <NumberFormat
            allowNegative={false}
            allowEmptyFormatting={false}
            decimalScale={0}
            value={elementoSelected.qtdAutorizada}
            onValueChange={({ floatValue }) => {
              this.handleChangeValueQtde(floatValue);
            }}
            onClick={this.handleFocusOnInput}
            customInput={TextField}
            className={classes.textField}
            InputProps={{
              classes: {
                input: classes.inputResize
              }
            }}
            inputProps={{
              type: 'number',
              min: 0,
              step: 1
            }}
          />
        </TableCell>
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') &&
          <TableCell className={classes.tableCell}>
            <NumberFormat
              prefix={'R$ '}
              thousandSeparator={'.'}
              decimalSeparator={','}
              decimalScale={elementoSelected.codTipoItem === 1 ? 2 : 3} // procedimentos com duas casas, opme e despesas com 3
              allowNegative={false}
              allowEmptyFormatting={false}
              value={elementoSelected.valUnitarioAutorizado}
              onValueChange={({ floatValue }) => { this.handleChangeValueUnitario(floatValue); }}
              onClick={this.handleFocusOnInput}
              className={classes.textField}
              customInput={TextField}
              InputProps={{
                classes: {
                  input: classes.inputResize
                }
              }}
            />
          </TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') &&
          <TableCell className={classes.tableCell} title={txtAjudaPercAutorizado}>
            <NumberFormat
              allowNegative
              allowEmptyFormatting={false}
              decimalScale={4}
              value={
                (elementoSelected.valPctReducaoAcrescimoAutorizado !== null)
                  ? elementoSelected.valPctReducaoAcrescimoAutorizado : null}
              onValueChange={({ floatValue }) => { this.handleChangeValuePct(floatValue); }}
              onClick={this.handleFocusOnInput}
              customInput={TextField}
              className={classes.textField}
              InputProps={{
                classes: {
                  input: classes.inputResize
                }
              }}
              inputProps={{
                type: 'number',
                step: 0.0001
              }}
            />
          </TableCell>}
        {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableCell} title='Valor que já foi Pago na guia original'>{this._currency(elementoSelected.elementoOriginalDTO.valTotalAutorizado)}</TableCell>}
        <TableCell className={classes.tableCell}>
          {elementoSelected.valTotalAutorizado === null ? ''
            : elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU
              ? this._currency(this._roundUp(elementoSelected.valTotalAutorizado, 2))
              : this._currency(elementoSelected.valTotalAutorizado)}
        </TableCell>

        {/* {elementoSelected.valTotalSolicitado - elementoSelected.valTotalAutorizado > 0 &&
          <TableCell className={classes.tableCellGlosa} title='Valor Total Glosado'>
            {this._currency(this._roundUp((elementoSelected.valTotalSolicitado - elementoSelected.valTotalAutorizado), 2))}
            </TableCell>} */}

        {elementoSelected.valTotalSolicitado - elementoSelected.valTotalAutorizado > 0 &&
          (this.state.situacaoElemento === 'negado' || this.state.situacaoElemento === 'glosado') ?
            <TableCell className={classes.tableCellGlosa} title='Valor Total Glosado'>
              {this._currency(this._roundUp((elementoSelected.valTotalSolicitado - elementoSelected.valTotalAutorizado), 2))}
            </TableCell>
          : <TableCell className={classes.tableCell}>-</TableCell>}


        <TableCell className={classes.tableCellMais}>
          {!readOnly &&
            <Toolbar className={classes.tableCellMaisToolbar} disableGutters>
              <Button
                color='primary'
                className={classes.buttonOperation}
                title='Autorizar Item...'
                onClick={() => this.autorizar(elementoSelected)}>
                <ThumbUpIcon />
              </Button>
              <Button
                color='primary'
                className={classes.buttonOperation}
                title='Negar Item'
                onClick={() => this.negar()}>
                <ThumbDownIcon />
              </Button>
              <Button
                color='primary'
                className={classes.buttonOperation}
                title='Calcular valor máximo autorizado...'
                onClick={() => this.maxTotalAutorizado()}>
                <TrendingUp />
              </Button>
              <Button
                disabled={!this.isPossivelDobrarValor()}
                color={!this.isPossivelDobrarValor() ? 'grey' : 'primary'}
                className={classes.buttonOperation}
                title='Calcular valor dobrado...'
                size='small'
                variant='outlined'
                onClick={() => this.dobrarValor()}>
                <Typography className={classnames(classes.typographyEnabled, {
                  [classes.typographyDisabled]: !this.isPossivelDobrarValor()
                })}>{'2x'}</Typography>
              </Button>
              <Button
                disabled={!this.isPossivelDividirMetade()}
                color={!this.isPossivelDividirMetade() ? 'grey' : 'primary'}
                className={classes.buttonOperation}
                title='Calcular metade do valor...'
                size='small'
                variant='outlined'
                onClick={() => this.dividirValorMetade()}>
                <Typography className={classnames(classes.typographyEnabled, {
                  [classes.typographyDisabled]: !this.isPossivelDividirMetade()
                })}>{'1/2'}</Typography>
              </Button>
              <Button
                disabled={this.isAuditoriaApagada()}
                color='primary'
                className={classes.buttonOperation}
                title='Apagar Auditoria...'
                onClick={() => this.apagar()}>
                <DeleteIcon />
              </Button>
              <Button
                disabled={!this.isElementoEmEdicao()}
                color='primary'
                className={classes.buttonOperation}
                title='Salvar auditoria...'
                onClick={() => this.salvarAuditoria(elementoSelected)}>
                <SaveIcon />
              </Button>
            </Toolbar>
          }
        </TableCell>
      </TableRow>
      : <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableRowCell}>Autorizado</TableCell>
        <TableCell className={classes.tableCell}>{elemento.qtdAutorizada !== null ? elemento.qtdAutorizada : ''}</TableCell>
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{elemento.valUnitarioAutorizado !== null ? this._currency(elemento.valUnitarioAutorizado) : ''}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell} title={txtAjudaPercAutorizado}>{elementoSelected.valPctReducaoAcrescimoAutorizado}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{elemento.valTotalAutorizado !== null ? this._currency(elemento.valTotalAutorizado) : ''}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCellGlosa}>
          {elemento.valTotalAutorizado !== null && elemento.valTotalSolicitado - elemento.valTotalAutorizado > 0 ? this._currency(elemento.valTotalSolicitado - elemento.valTotalAutorizado) : ''}
          </TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCellMais} />}
      </TableRow >;

    const txtAjudaPercVigente =
      `${elementoSelected.valTaxaVigente === '1.0000' ||
        elementoSelected.valTaxaVigente === '0.0000' ||
        elementoSelected.valTaxaVigente === null
        ? 'Nenhuma taxa vigente.'
        : `Taxa vigente é de ${parseFloat((elementoSelected.valTaxaVigente - 1) * 100).toFixed(2)}%.`}`;

    const rowVigente = <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableRowCell}>Vigente</TableCell>
      <TableCell className={classes.tableCell} />
      <TableCell className={classes.tableCell}>{this._currency(this._roundUp(elemento.valUnitarioVigente, 3))}</TableCell>
      <TableCell className={classes.tableCell} title={txtAjudaPercVigente}>{elemento.valTaxaVigente !== null ? elemento.valTaxaVigente : null}</TableCell>
      {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableCell} />}
      <TableCell className={classes.tableCellMaisGlosa} />
      {/* {elementoSelected.valTotalSolicitado - elementoSelected.valTotalAutorizado > 0 &&
        <TableCell className={classes.tableCellGlosa} title='Valor Total Glosado'>{this._currency(this._roundUp((elementoSelected.valTotalSolicitado - elementoSelected.valTotalAutorizado), 2))}</TableCell>} */}
    </TableRow >;

    const adicionarMotivoGlosa =
      this.isElementoAuditado(elementoSelected) &&
      this.haGlosa(elementoSelected) &&
      emAuditoria && !readOnly &&
      <Typography
        component={'span'}
        className={classes.editableClick}
        onClick={() => this.addGlosaElemento(elementoSelected)}>Adicionar motivo de glosa
      </Typography>;

    return (
      <React.Fragment>
        <Slide key={idx} direction='right' timeout={600} in mountOnEnter unmountOnExit>
          <Paper
            key={idx}
            className={`${classes.root} ${this.styleSituacaoElemento(this.getSituacao(elementoSelected))}`}
            onFocus={() => this.handleClickOnElemento(idx, elemento)}>
            {titleElemento}
            <Table>
              <TableHead>
                {rowHead}
              </TableHead>
              <TableBody className={classes.tableBody}>
                {rowSolicitado}
                {rowAutorizado}
                {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && rowVigente}
              </TableBody>
            </Table>
            {adicionarMotivoGlosa}
          </Paper>
        </Slide>
        {this.state.openDialogGlosaElemento &&
          <AlertDialogSlideGlosa
            open={this.state.openDialogGlosaElemento}
            handleClose={this.handleCloseDialogGlosaElemento}
            handleClickIncluirGlosa={this.handleConfirmDialogGlosaElemento}
            title={'Adicionar motivo de glosa do item'}
            message={''} />}

        {this.state.openDrawerGuiasDuplicidade &&
          <DrawerGuiasDuplicidade
            open={this.state.openDrawerGuiasDuplicidade}
            guias={this.props.guiasEmDuplicidade}
            handleClose={this.handleDrawerCloseGuiaDuplicidade}
          />}
          
        {this.state.openDialogAnexos &&
          <FormDialogAnexarDocumentos
            titulo={'Visualizar Anexos'}
            arquivos={this.state.elementoSelected.arquivos}
            idElemento={this.state.elementoSelected.id}
            codTipoItem={this.state.elementoSelected.tipoElementoGuia}
            open={this.state.openDialogAnexos}
            isUnimed={false}
            handleClose={this.handleDialogCloseAnexos} />}
        <AlertDialog
          open={this.state.openDialogJustificativa}
          handleClose={this.handleCloseDialogJustificativa}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage} />
        <AlertDialogSlide
          open={this.state.openDialogGlosaEmLote}
          handleClose={this.handleCloseDialogGlosaEmLote}
          handleClick={this.handleDialogConfirmGlosaEmLote}
          title={this.state.dialogTitleGlosaEmLote}
          message={this.state.dialogMessageGlosaEmLote} />
      </React.Fragment>
    );
  }
}
export default withAuditoria(withSnackbar(withLoading(withStyles(styles)(Elemento))));
